// extracted by mini-css-extract-plugin
export default {"wrap":"TK-z","fullWidth":"UK-z","hideOnDesktop":"VK-z","content":"WK-z","hasOpenedNav":"XK-z","crumbsList":"YK-z","dropdownsWrap":"ZK-z"};